// extracted by mini-css-extract-plugin
export default {"logo":"K2HwrdUNLpkEKTJPuxvMMQ==","dougsLogoText":"bWCvpqfwd5MvDGoiico5yQ==","dougsLogoIcon":"TLtYnKkeE+UeKHJ+jK6UnQ=="};